import * as AppConfig from './app-config';

export default AppConfig;
